import { useState, useEffect } from "react";
import { useAddDiscountMutation } from "services/discount";
import { useNavigate, useParams } from "react-router-dom";
import ShowToast from "components/MDToast";

import {
  Card,
  Grid,
  Box,
  FormControlLabel,
  Checkbox,
  Input,
  Select,
  MenuItem,
  Button,
  CardMedia,
  styled,
  FormControl,
} from "@mui/material";
import { InputLabel } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CommonLayout from "components/CommonLayout";
import bgImage from "assets/images/background.png";
import product1 from "assets/images/product1.png";
import CancelIcon from "@mui/icons-material/Cancel";
import { useGetAllProductsMutation } from "services/product";
import { UploadMedia } from "utils/mediaUpload";
import { useLazyGetDiscountByIdQuery } from "services/discount";
import { useUpdateDiscountMutation } from "services/discount";
import { useAddCouponMutation } from "services/coupon";
import { useUpdateCouponMutation } from "services/coupon";
import { useLazyGetCouponByIdQuery } from "services/coupon";
import useTranslation from "hooks/Translation";

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "#ff5722",
  "&.Mui-checked": {
    color: "#ff9800",
  },
}));

const AddDiscount = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const t = useTranslation();
  const [addDiscount] = useAddCouponMutation();
  const [updateBanner] = useUpdateCouponMutation();
  const [getProducts] = useGetAllProductsMutation();
  const [productData, setProductData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [discountBIdApi] = useLazyGetCouponByIdQuery();
  const [discountById, setDiscountById] = useState({});
  const [errors, setErrors] = useState(false);
  const [imageId, setImageId] = useState(0);
  const [imageError, setImageError] = useState("");
  const [selectedBannerType, setSelectedBannerType] = useState("");
  const [profilePicture, setProfilePicture] = useState("");

  const callDisCountByIdApi = async () => {
    try {
      const res = await discountBIdApi({ id }).unwrap();
      if (res?.status === 200) {
        setDiscountById(res?.data);
        if (res?.data?.banner_image) {
          formik.setFieldValue("createBanner", true);
        }
        setSelectedProduct(res?.data?.product?.id);
        setProfilePicture(res?.data?.banner_image?.media_url);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getProducts({ start: 1, length: 10 }).unwrap();
        if (response?.status === 200) {
          setProductData(response?.data?.response_object);
        } else {
          setProductData([]);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchProducts();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      discount_name_en: discountById?.discount_name_en || "",
      discount_name_ar: discountById?.discount_name_ar || "",
      discount_name_rs: discountById?.discount_name_rs || "",
      discountPercentage: discountById?.discount_percentage || "",
      discount_description_en: discountById?.description_en || "",
      discount_description_ar: discountById?.description_ar || "",
      discount_description_rs: discountById?.description_rs || "",
      startDate: discountById?.start_date || "",
      startTime: discountById?.start_time || "",
      endDate: discountById?.end_date || "",
      endTime: discountById?.end_time || "",
      bannerImage: null,
      createBanner: discountById?.banner_image ? true : false,
    },
    validationSchema: Yup.object({
      discount_name_en: Yup.string().required(t.error.required),
      discount_name_ar: Yup.string().required(t.error.required),
      discount_name_rs: Yup.string().required(t.error.required),
      discountPercentage: Yup.number().required(t.error.required),
      startDate: Yup.string().required(t.error.required),
      endDate: Yup.string().required(t.error.required),
      startTime: Yup.string().required(t.error.required),
      endTime: Yup.string().required(t.error.required),
      discount_description_en: Yup.string().required(t.error.required),
      discount_description_ar: Yup.string().required(t.error.required),
      discount_description_rs: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      if (!profilePicture && values.createBanner) {
        ShowToast(t.error.uploadBanner, "error");
        return;
      }

      const body = {
        discount_name_ar: values.discount_name_ar || "",
        discount_name_en: values.discount_name_en || "",
        discount_name_rs: values.discount_name_rs || "",
        discount_percentage: values.discountPercentage,
        description_ar: values.discount_description_ar || "",
        description_en: values.discount_description_en,
        description_rs: values.discount_description_rs,
        start_date: values.startDate,
        start_time: values.startTime,
        end_date: values.endDate,
        end_time: values.endTime,
        is_banner: false,
        product: selectedProduct,
      };

      console.log(body, "_______<<<<<<<<<");
      try {
        if (id) {
          const response = await updateBanner({
            id: id,
            body: body,
          }).unwrap();
          if (response.status === 200) {
            ShowToast(t.main.discountUpdated);
            // navigate("/manage-Banners");
          } else {
            ShowToast(response.message, "error");
          }
        } else {
          const response = await addDiscount(body).unwrap();
          if (response.status === 200) {
            ShowToast(t.main.discountAdded);
            navigate("/manage-discount");
            // navigate("/manage-Banners");
          } else {
            ShowToast(response.message, "error");
          }
        }
      } catch (e) {
        ShowToast(e?.data?.message);
      }
    },
  });

  const handleTypeChange = (event) => {
    setSelectedBannerType(event.target.value);
  };

  const handleChangeProduct = (event) => {
    setSelectedProduct(event.target.value);
  };

  useEffect(() => {
    if (id) {
      callDisCountByIdApi();
    }
  }, []);

  return (
    <CommonLayout image={bgImage}>
      <Card sx={{ marginTop: 10, marginBottom: 10 }}>
        <MDBox
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {id ? t.main.editDiscount : t.main.addDiscount}
          </MDTypography>

          <MDTypography
            variant="h6"
            color="white"
            mt={1}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/manage-discount")}
          >
            {t.main.back}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              {/* Product Selection */}
              <Grid item lg={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.selectProduct}
                </MDTypography>
                <Select
                  labelId="product-label"
                  id="demo-simple-select"
                  value={selectedProduct}
                  onChange={handleChangeProduct}
                  fullWidth
                  className="select_div"
                  error={
                    formik.touched.product && Boolean(formik.errors.product)
                  }
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  sx={{
                    border:
                      errors && !selectedProduct
                        ? "1px solid red"
                        : "1px solid grey", // Add a custom border color
                    borderRadius: "6px", // Optional: Add border radius for styling
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "grey", // Adjust border color for the outlined variant
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "grey", // Border color on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "grey", // Border color when focused
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    {t.main.selectProduct}
                  </MenuItem>
                  {productData.map((product) => (
                    <MenuItem key={product.id} value={product.id}>
                      {product.product_name_en}
                    </MenuItem>
                  ))}
                </Select>
                {errors && !selectedProduct ? (
                  <MDTypography className="err_msg">
                    {t.error.required}
                  </MDTypography>
                ) : (
                  ""
                )}
              </Grid>

              {/* Discount Name Fields */}
              <Grid item lg={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.discountNameEn}
                </MDTypography>
                <MDInput
                  fullWidth
                  name="discount_name_en"
                  placeholder={t.main.discountNameEn}
                  value={formik.values.discount_name_en}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.discount_name_en &&
                    Boolean(formik.errors.discount_name_en)
                  }
                  helperText={
                    formik.touched.discount_name_en &&
                    formik.errors.discount_name_en
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.discountNameAr}
                </MDTypography>
                <MDInput
                  fullWidth
                  name="discount_name_ar"
                  placeholder={t.main.discountNameAr}
                  value={formik.values.discount_name_ar}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.discount_name_ar &&
                    Boolean(formik.errors.discount_name_ar)
                  }
                  helperText={
                    formik.touched.discount_name_ar &&
                    formik.errors.discount_name_ar
                  }
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.discountNameRu}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.discountNameRu}
                    variant="outlined"
                    fullWidth
                    name="discount_name_rs"
                    value={formik.values.discount_name_rs}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.discount_name_rs &&
                      Boolean(formik.errors.discount_name_rs)
                    }
                    helperText={
                      formik.touched.discount_name_rs &&
                      formik.errors.discount_name_rs
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.discountPercentage}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.discountPercentage}
                    variant="outlined"
                    fullWidth
                    name="discountPercentage"
                    value={formik.values.discountPercentage}
                    onChange={(val) => {
                      const value = val.target.value;
                      if (value === " " || value === ".") return;

                      // Regex to allow only numbers with up to two decimal places
                      if (/^\d*\.?\d{0,2}$/.test(value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.discountPercentage &&
                      Boolean(formik.errors.discountPercentage)
                    }
                    helperText={
                      formik.touched.discountPercentage &&
                      formik.errors.discountPercentage
                    }
                  />
                </MDBox>
              </Grid>
              {/* Description Fields */}
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.descEng}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.descEng}
                    variant="outlined"
                    fullWidth
                    name="discount_description_en"
                    value={formik.values.discount_description_en}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.discount_description_en &&
                      Boolean(formik.errors.discount_description_en)
                    }
                    helperText={
                      formik.touched.discount_description_en &&
                      formik.errors.discount_description_en
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.descAr}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.descAr}
                    variant="outlined"
                    fullWidth
                    name="discount_description_ar"
                    value={formik.values.discount_description_ar}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.discount_description_ar &&
                      Boolean(formik.errors.discount_description_ar)
                    }
                    helperText={
                      formik.touched.discount_description_ar &&
                      formik.errors.discount_description_ar
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.descRu}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="text"
                    placeholder={t.main.descRu}
                    variant="outlined"
                    fullWidth
                    name="discount_description_rs"
                    value={formik.values.discount_description_rs}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.discount_description_rs &&
                      Boolean(formik.errors.discount_description_rs)
                    }
                    helperText={
                      formik.touched.discount_description_rs &&
                      formik.errors.discount_description_rs
                    }
                  />
                </MDBox>
              </Grid>
              {/* Date and Time Fields */}
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.startDate}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="date"
                    variant="outlined"
                    fullWidth
                    name={t.main.startDate}
                    value={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.startDate &&
                      Boolean(formik.errors.startDate)
                    }
                    helperText={
                      formik.touched.startDate && formik.errors.startDate
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.endDate}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="date"
                    variant="outlined"
                    fullWidth
                    name={t.main.endDate}
                    value={formik.values.endDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.endDate && Boolean(formik.errors.endDate)
                    }
                    helperText={formik.touched.endDate && formik.errors.endDate}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.startTime}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="time"
                    variant="outlined"
                    fullWidth
                    name={t.main.startTime}
                    value={formik.values.startTime}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.startTime &&
                      Boolean(formik.errors.startTime)
                    }
                    helperText={
                      formik.touched.startTime && formik.errors.startTime
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.endTime}
                </MDTypography>
                <MDBox>
                  <MDInput
                    type="time"
                    variant="outlined"
                    fullWidth
                    name={t.main.endTime}
                    value={formik.values.endTime}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.endTime && Boolean(formik.errors.endTime)
                    }
                    helperText={formik.touched.endTime && formik.errors.endTime}
                  />
                </MDBox>
              </Grid>

              {/* Banner Image Upload */}

              {/* Submit Button */}
            </Grid>
            <MDButton
              variant="gradient"
              color="success"
              sx={{ marginTop: 4 }}
              type="submit"
              onClick={() => setErrors(true)}
            >
              {t.main.save}
            </MDButton>
          </form>
        </MDBox>
      </Card>
    </CommonLayout>
  );
};

export default AddDiscount;
